<!-- <button class="arrow-open">
<i class="fa-solid fa-angle-left"></i>
</button> -->
<main class="container" *transloco="let t" id="content">

  @if (error) {
    <alert [type]="'warning'" [dismissOnTimeout]="3500">
      <span *transloco="let t">
        @if (error_code) {
          <span>{{t('error.report_code_support', { code: error_code})}}</span>
        }
        @if (!error_code) {
          <span>{{t(error)}}</span>
        }
      </span>
    </alert>
  }

  @if (survey) {
    <div class="mb-4">
      <div class="survey-header">
        <div class="row mt-5">
          <div class="col-lg-5">
            @if (survey.images | imageForRole:'thumbnail':true; as cover) {
              <img class="w-100 mb-4"
                [src]="cover | imageUrl:thumbnailTransformations"
                [alt]="cover.alt_text">
            }
          </div>
          <div class="col-lg-7">
            <div class="">
              <h2 class="h1 font-weight-bold mt-0">{{survey.name}}</h2>
              <p>{{survey.description}}</p>
              <div class="d-flex flex-row align-items-center mt-3">
                <p class="card-text">
                  @if (survey?.updated_at >= survey?.updated_at) {
                    <span class="page-title">
                      <small>{{t('common.published')}} {{survey.updated_at | date :
                      'longDate'}}</small>
                    </span>
                  } @else {
                    <small>{{t('common.updated')}} {{survey.updated_at | date : 'longDate'}}</small>
                  }
                  <ng-template #updated>
                    <small>{{t('common.updated')}} {{survey.updated_at | date : 'longDate'}}</small>
                  </ng-template>
                </p>
                <div class="mx-2 text-muted">|</div>
                @if (survey.rating) {
                  <div>
                    <span style="margin:15px 0;"> {{roundRating(survey.rating)}} </span>
                    <rating ngClass="text-warning" [(ngModel)]="survey.rating" [max]="ratingMax" [readonly]="true">
                    </rating>
                  </div>
                }
              </div>
              @if (loadingObject.content) {
                <multisite-loader-globe-animation-detail
                  [width]="60"
                  [height]="60"
                  >
                </multisite-loader-globe-animation-detail>
              }
              @if (survey.cultures?.length + survey.topics?.length <= 6) {
                <div class="d-flex flex-row align-items-center justify-content-start align-self-start flex-wrap gap-2 my-2">
                  @for (culture of survey.cultures && survey.cultures.length > 1 ? survey.cultures : []; track culture) {
                    <multisite-avatar-pill
                      class="mt-1"
                      [fallbackImageUrl]="getFallbackFlagUrl()"
                      [fallbackTranslationKey]="'tracking.missing'"
                      [clickable]="false"
                      [imageUrl]="cloudinary_base_url+'w_32,c_fill,ar_1:1,r_max/flags/round/'+culture.flag?.hash+'.png'"
                      [text]="culture.name"
                      [hideBackground]="false"
                      [compact]="true"
                    ></multisite-avatar-pill>
                  }
                  @for (topic of survey.topics && survey.topics.length > 2 ? survey.topics : []; track topic) {
                    <multisite-icon-pill
                      [icon]="topic.icon"
                      [fallbackIconClasses]="'fa-solid fa-star'"
                      [labelText]="topic.name ?? 'Fake name'"
                      [selectable]="false"
                      [inverted]="false"
                      [shape]="'round'"
                      [compact]="true"
                      >
                    </multisite-icon-pill>
                  }
                </div>
              }
              <div class="mt-3" *transloco="let t">
                @if (false) {
                  <p class="h1 font-weight-bold">$122.95</p>
                }
                @if (!user && survey.allow_guests) {
                  <div class="d-flex flex-column gap-3">
                    <p *transloco="let t; scope: 'survey'">{{t('survey.log_in_for_extra_feedback')}}</p>
                    <button class="btn btn-primary w-50 w-lg-100 btn-lg" (click)="goToLogin()">
                      <span>{{t('common.log_in')}}</span>
                    </button>
                  </div>
                }
                @if (!user && !guest && survey.allow_guests) {
                  <div class="row align-items-center mt-2">
                    @if (!loadingNewGuestError) {
                      <a (click)="makeGuest()" class="link-secondary">
                        <span>{{t('authentication.no_thanks_continue_without_login')}}</span>
                      </a>
                    }
                    @if (loadingNewGuestError) {
                      <span class="text-warning">
                        {{t(loadingNewGuestError)}}
                      </span>
                    }
                    @if (loadingObject.new_guest) {
                      <span>
                        <multisite-loader-globe-animation-detail [width]="30"
                        [height]="30"></multisite-loader-globe-animation-detail>
                        <span>{{t('authentication.creating_guest')}}</span>
                      </span>
                    }
                    <!-- <button *ngIf="prefersToContinueWithoutLoggingIn && !loadingObject.new_guest" class="btn btn-primary w-50" (click)="startSurvey()">
                    <span *transloco="let t">{{t('authentication.continue_without_login')}}</span>
                  </button> -->
                </div>
              }
              @if (user || guest) {
                <div class="row align-items-center mt-2">
                  <div class="col-lg-6">
                    <button class="btn btn-primary w-100 btn-lg" (click)="startSurvey()">
                      @if (!user && !guest) {
                        <span>{{t('common.start')}}</span>
                      }
                      @if (user || guest) {
                        <span>{{surveyProgressValue > 99 ? t('common.view_feedback') : started ?
                        t('common.continue') : t('common.start')}}</span>
                      }
                    </button>
                  </div>
                  <div class="col-lg-6">
                    @if (loadingObject.starting) {
                      <multisite-loader-globe-animation-detail [width]="60" [height]="60"
                      ></multisite-loader-globe-animation-detail>
                    }
                    <!-- <div class="d-flex align-items-center justify-content-center justify-content-md-start mt-2 mt-md-0">
                    <img width="32px" height="32px" src="https://iili.io/HH2EezN.png" alt="rosette">
                    <span class="ml-1">Required for accreditation</span>
                  </div> -->
                </div>
              </div>
            }
            <div class="d-flex flex-wrap gap-2 my-2 align-items-start justify-content-start">
              @if (survey?.instructions?.length && started && (!surveyProgressValue || surveyProgressValue < 99)) {
                <button class="btn btn-sm" routerLink="instructions"
                  >
                  <i class="fa fa-person-chalkboard" aria-hidden="true"></i>
                  {{t('common.instructions')}}
                </button>
              }
              @if (started && languagePreferenceOptionIsAvailable() && (!surveyProgressValue || surveyProgressValue < 99)) {
                <button class="btn btn-sm" [routerLink]="['language']"
                  >
                  <i class="fa fa-language" aria-hidden="true"></i>
                  {{t('navigation.language_preferences')}}
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  @if (survey.cultures?.length + survey.topics?.length > 6) {
    <div class="d-flex flex-row align-items-center justify-content-start align-self-start flex-wrap gap-2 my-2">
      @for (culture of survey.cultures && survey.cultures.length > 1 ? survey.cultures : []; track culture) {
        <multisite-avatar-pill
          class="mt-1"
          [fallbackImageUrl]="getFallbackFlagUrl()"
          [fallbackTranslationKey]="'tracking.missing'"
          [clickable]="false"
          [imageUrl]="cloudinary_base_url+'w_32,c_fill,ar_1:1,r_max/flags/round/'+culture.flag?.hash+'.png'"
          [text]="culture.name"
          [hideBackground]="false"
          [compact]="true"
        ></multisite-avatar-pill>
      }
      @for (topic of survey.topics && survey.topics.length > 2 ? survey.topics : []; track topic) {
        <multisite-icon-pill
          [icon]="topic.icon"
          [fallbackIconClasses]="'fa-solid fa-star'"
          [labelText]="topic.name ?? 'Fake name'"
          [selectable]="false"
          [inverted]="false"
          [shape]="'round'"
          [compact]="true"
          >
        </multisite-icon-pill>
      }
    </div>
  }
</div>
}





@if (contributors?.length) {
  <div class="mt-5 mx-3">
    <p class="h4 font-weight-bold mb-3">{{contributors.length===1 ?
    t('common.contributor'):t('common.contributors')}}</p>
    <div class="mt-3">
      <!-- TODO group contributors by role: translations, creators etc -->
      <!-- <p class="text-muted mb-1">{{contributors.length===1 ?
    t('common.contributor'):t('common.contributors')}}</p> -->
    <div class="contributors">
      @for (contributor of contributors; track contributor) {
        <multisite-avatar-pill
          [fallbackImageUrl]="'https://res.cloudinary.com/cebt/image/upload/w_24,h_24/v1616972586/users/avatars/default-avatar.gif'"
          [fallbackTranslationKey]="'social.verified_user'" [imageUrl]="contributor.user | userAvatar" [text]="(contributor.user.pre_honorific ? (contributor.user.pre_honorific+' ') : '') + contributor.user.fname+' '+contributor.user.lname+ (contributor.user.post_honorific ? ' '+contributor.user.post_honorific : '')"></multisite-avatar-pill>
      }
    </div>
  </div>
</div>
}

@if (loadingObject.survey) {
  <div>
    <multisite-loader-globe-animation-detail [width]="100" [height]="100"></multisite-loader-globe-animation-detail>
  </div>
}


</main>

<ng-template #blockingSnapshotModal>
  <div class="modal-header" *transloco="let t">
    <h4 class="h4 font-weight-bold mb-0">
      {{t('survey.snapshot_too_many_same_time')}}
    </h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
      <span aria-hidden="true">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </button>
  </div>
  <div class="modal-body overflow-hidden" *transloco="let t">

    <p class="my-3">
      <span> {{t('survey.other_snapshot_active')}}</span>
      @if (snapshot?.current_accepted) {
        <span> {{t('survey.cancel_snapshot_help_current_accepted')}}</span>
      }
    </p>

    <div class="my-3">

      <div class="card">
        <div class="card-body">
          <h5 class="card-title">{{t('survey.snapshot_active')}}</h5>
          <span class="card-text">{{blockingSnapshot?.label ?? blockingSnapshot?.title}}</span>
        </div>
      </div>
    </div>

    <button class="btn btn-primary" (click)="closeModal()">{{t('common.no_go_back')}}</button>
    <button class="btn btn-warning" (click)="goToSnapshot(blockingSnapshot)">{{t('common.go')}}</button>


  </div>
</ng-template>